import { useMemo } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../hooks/useProfiler.js";
import usePointOfSale from "../../../../../hooks/usePointOfSale.js";
export function useDSATraceabilityController(props) {
    const { flight } = props;
    const i18n = useI18n();
    const pos = usePointOfSale();
    const { isEEA, isMobile } = useProfiler();
    const isColombia = pos === "co";
    const text = useMemo(() => i18n.trans(t("flights_fd_powered_by_gotogate")), [i18n]);
    const title = useMemo(() => i18n.trans(t("flights_fd_modal_powered_by_gotogate")), [i18n]);
    const a11yTooltip = useMemo(() => i18n.trans(t("a11y_flights_fd_gotogate_tooltip")), [i18n]);
    const a11yClose = useMemo(() => i18n.trans(t("a11y_flights_gotogate_bottomsheet_close")), [i18n]);
    const content = useMemo(() => isColombia
        ? [
            i18n.trans(t("flights_fd_modal_gotogate_legal_entity_co")),
            i18n.trans(t("flights_fd_modal_gotogate_trade_reg_co")),
            i18n.trans(t("flights_fd_modal_gotogate_rnt_co")),
            " ",
            i18n.trans(t("flights_fd_modal_gotogate_address_co")),
            i18n.trans(t("flights_fd_modal_gotogate_tel_co")),
            " ",
            i18n.trans(t("flights_fd_modal_gotogate_compliance_co"))
        ]
        : [
            i18n.trans(t("flights_fd_modal_gotogate_legal_entity")),
            i18n.trans(t("flights_fd_modal_gotogate_trade_reg_name")),
            i18n.trans(t("flights_fd_modal_gotogate_reg_num")),
            " ",
            i18n.trans(t("flights_fd_modal_gotogate_address_one")),
            i18n.trans(t("flights_fd_modal_gotogate_phone")),
            " ",
            i18n.trans(t("flights_fd_modal_gotogate_products_and_services"))
        ], [i18n, isColombia]);
    const shouldRender = useMemo(() => {
        if (isMobile() && !flight)
            return false;
        if (!isEEA() && !isColombia)
            return false;
        return true;
    }, [flight, isEEA, isMobile, isColombia]);
    return {
        a11yClose,
        a11yTooltip,
        content,
        shouldRender,
        text,
        title
    };
}
